export default {
      id: "ar_transports-usage",
      viewBox: "0 0 90 75",
      url: "../dist/images/" + "sprite.svg#ar_transports-usage",
      toString: function () {
        return this.url;
      }
    }